var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.proceed.apply(null, arguments)
        },
        keydown: function($event) {
          return _vm.marriageForm.errors.clear($event.target.name)
        }
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [_vm._v("Date of Marriage")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.marriageForm.date_of_marriage,
                    expression: "marriageForm.date_of_marriage"
                  }
                ],
                staticClass: "form-control",
                class: {
                  "is-invalid": _vm.marriageForm.errors.has("date_of_marriage")
                },
                attrs: { type: "date" },
                domProps: { value: _vm.marriageForm.date_of_marriage },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.marriageForm,
                      "date_of_marriage",
                      $event.target.value
                    )
                  }
                }
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: {
                  "form-name": _vm.marriageForm,
                  "prop-name": "date_of_marriage"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [_vm._v("Marriage Location")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.marriageForm.location,
                    expression: "marriageForm.location"
                  }
                ],
                staticClass: "form-control",
                class: {
                  "is-invalid": _vm.marriageForm.errors.has("location")
                },
                attrs: { type: "text" },
                domProps: { value: _vm.marriageForm.location },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.marriageForm, "location", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: {
                  "form-name": _vm.marriageForm,
                  "prop-name": "location"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [_vm._v("Officiated By")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.marriageForm.officiated_by,
                    expression: "marriageForm.officiated_by"
                  }
                ],
                staticClass: "form-control",
                class: {
                  "is-invalid": _vm.marriageForm.errors.has("officiated_by")
                },
                attrs: { type: "text" },
                domProps: { value: _vm.marriageForm.officiated_by },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.marriageForm,
                      "officiated_by",
                      $event.target.value
                    )
                  }
                }
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: {
                  "form-name": _vm.marriageForm,
                  "prop-name": "officiated_by"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [_vm._v("Husband's NIN Number")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.marriageForm.couples_nin_husband,
                    expression: "marriageForm.couples_nin_husband"
                  }
                ],
                staticClass: "form-control",
                class: {
                  "is-invalid": _vm.marriageForm.errors.has(
                    "couples_nin_husband"
                  )
                },
                attrs: { type: "text" },
                domProps: { value: _vm.marriageForm.couples_nin_husband },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.marriageForm,
                      "couples_nin_husband",
                      $event.target.value
                    )
                  }
                }
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: {
                  "form-name": _vm.marriageForm,
                  "prop-name": "couples_nin_husband"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [_vm._v("Wife's NIN Number")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.marriageForm.couples_nin_wife,
                    expression: "marriageForm.couples_nin_wife"
                  }
                ],
                staticClass: "form-control",
                class: {
                  "is-invalid": _vm.marriageForm.errors.has("couples_nin_wife")
                },
                attrs: { type: "text" },
                domProps: { value: _vm.marriageForm.couples_nin_wife },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.marriageForm,
                      "couples_nin_wife",
                      $event.target.value
                    )
                  }
                }
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: {
                  "form-name": _vm.marriageForm,
                  "prop-name": "couples_nin_wife"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [_vm._v("Husband's Phone Number")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.marriageForm.couples_phone_husband,
                    expression: "marriageForm.couples_phone_husband"
                  }
                ],
                staticClass: "form-control",
                class: {
                  "is-invalid": _vm.marriageForm.errors.has(
                    "couples_phone_husband"
                  )
                },
                attrs: { type: "text" },
                domProps: { value: _vm.marriageForm.couples_phone_husband },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.marriageForm,
                      "couples_phone_husband",
                      $event.target.value
                    )
                  }
                }
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: {
                  "form-name": _vm.marriageForm,
                  "prop-name": "couples_phone_husband"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [_vm._v("Wife's Phone Number")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.marriageForm.couples_phone_wife,
                    expression: "marriageForm.couples_phone_wife"
                  }
                ],
                staticClass: "form-control",
                class: {
                  "is-invalid": _vm.marriageForm.errors.has(
                    "couples_phone_wife"
                  )
                },
                attrs: { type: "text" },
                domProps: { value: _vm.marriageForm.couples_phone_wife },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.marriageForm,
                      "couples_phone_wife",
                      $event.target.value
                    )
                  }
                }
              }),
              _vm._v(" "),
              _c("show-error", {
                attrs: {
                  "form-name": _vm.marriageForm,
                  "prop-name": "couples_phone_wife"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c("h6", { staticClass: "text-bold-600 mt-2" }, [
              _vm._v("Participants")
            ]),
            _vm._v(" "),
            _vm._l(_vm.marriageForm.participants, function(participant, index) {
              return _c(
                "div",
                { key: index, staticClass: "border p-2 mb-2 rounded bg-light" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Role")]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: participant.role,
                                expression: "participant.role"
                              }
                            ],
                            staticClass: "form-control",
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  participant,
                                  "role",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("Select Role")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "husband" } }, [
                              _vm._v("Husband")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "wife" } }, [
                              _vm._v("Wife")
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "witness" } }, [
                              _vm._v("Witness")
                            ])
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Name")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: participant.name,
                              expression: "participant.name"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: participant.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(participant, "name", $event.target.value)
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-2" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Age")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: participant.age,
                              expression: "participant.age"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "number" },
                          domProps: { value: participant.age },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(participant, "age", $event.target.value)
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-4" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Profession")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: participant.profession,
                              expression: "participant.profession"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: participant.profession },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                participant,
                                "profession",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Father's Name")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: participant.father_name,
                              expression: "participant.father_name"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: participant.father_name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                participant,
                                "father_name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Father's Profession")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: participant.father_profession,
                              expression: "participant.father_profession"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: participant.father_profession },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                participant,
                                "father_profession",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Present Condition")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: participant.present_condition,
                              expression: "participant.present_condition"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: participant.present_condition },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                participant,
                                "present_condition",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [_vm._v("Address")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: participant.address,
                              expression: "participant.address"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: participant.address },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                participant,
                                "address",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 text-right" }, [
                      index > 0
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-danger",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.removeParticipant(index)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                            Remove\n                        "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ])
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.addParticipant }
              },
              [_vm._v("\n                Add Participant\n            ")]
            )
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-3" }, [
        _c(
          "div",
          { staticClass: "col-md-8 offset-md-4" },
          [
            _c(
              "button-spinner",
              {
                staticClass:
                  "btn btn-primary mr-1 mb-1 waves-effect waves-light pull-right",
                staticStyle: { height: "39px", color: "#fff" },
                attrs: {
                  "is-loading": _vm.marriageForm.isLoading,
                  disabled: _vm.marriageForm.isLoading
                }
              },
              [
                _vm.id
                  ? _c("span", [_vm._v(_vm._s(_vm.trans("general.update")))])
                  : _c("span", [_vm._v(_vm._s(_vm.trans("general.save")))])
              ]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass:
                  "btn btn-danger waves-effect waves-light pull-right mr-1 mb-1",
                attrs: { to: "/marriage-certificate" }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.trans("general.cancel")) +
                    "\n            "
                )
              ]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }